import { connect } from 'react-redux';
import { GET_TRANSFORMED_SAMPLES_FROM_FLAT_TO_NEST_REQUEST } from 'js/constants/actionTypes';
import {
  probeGetKafkaTopicSample,
  fetchTransformedPayloadFromEditorForRest,
  updateFormData,
} from 'js/actions';
import KafkaSinkConfig from './KafkaSinkConfig';

const mapStateToProps = (state, ownProps) => {
  const { forms, probe, request, paging } = state;
  const { selectedCredentialId, sinkConfigFields } = ownProps;
  const { error, topics, queues } = probe[selectedCredentialId] || {};
  const formType = forms.activeType;
  const form = forms[formType];
  const formData = form && form.data ? form.data : {};
  const {
    dataSetId,
    toNested,
    previewPayload,
    previewPayloadError,
    selectedTopic,
    isNewTopicChecked,
    newTopicName,
    subscription,
    sinkConfig,
    sink,
  } = formData || {};
  const isLoadingPayload = !!request[GET_TRANSFORMED_SAMPLES_FROM_FLAT_TO_NEST_REQUEST];

  return {
    paging,
    formType,
    error,
    topics,
    queues,
    dataSetId,
    toNested,
    previewPayload,
    previewPayloadError,
    selectedTopic,
    isNewTopicChecked,
    newTopicName,
    subscription,
    sinkConfig,
    sink,
    isLoadingPayload,
    sinkConfigFields,
  };
};

export default connect(mapStateToProps, {
  probeGetKafkaTopicSample,
  fetchTransformedPayloadFromEditorForRest,
  updateFormData,
})(KafkaSinkConfig);
